import { render, staticRenderFns } from "./dragonCity.vue?vue&type=template&id=2a2dc749"
import script from "./dragonCity.vue?vue&type=script&lang=js"
export * from "./dragonCity.vue?vue&type=script&lang=js"
import style0 from "./dragonCity.vue?vue&type=style&index=0&id=2a2dc749&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports